import { CSSProperties } from "react";

export const hoverLabelStyle = (isOver: boolean, size?: number): CSSProperties => (isOver ? {
  backgroundColor: '#f0f0f0',
  border: '2px dashed #000', 
  height: size ? `${size}px` : '30px',
  display: 'flex',
  alignItems: 'center',
} : {})